var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-1a9bb897]{margin:0}.page_con p[data-v-1a9bb897]{font-size:22px;color:#929dad;line-height:36px}.page_con p span[data-v-1a9bb897]{color:rgba(0,0,0,.85)}.page_con p[data-v-1a9bb897]:first-child{background:url(" + escape(require("@/assets/image/expense.png")) + ") no-repeat left center;background-size:contain;padding-left:45px;margin-right:60px}.page_con p[data-v-1a9bb897]:last-child{background:url(" + escape(require("@/assets/image/income.png")) + ") no-repeat left center;background-size:contain;padding-left:45px}.des[data-v-1a9bb897]{text-align:center;font-size:20px}.des span[data-v-1a9bb897]{color:#000;font-size:30px}", ""]);

// exports
